import { Grid } from "@mui/material";
import CopyToClipboard from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { successAlert } from "utils/alertHandler";

export default function PaymentMethodPage() {
  const { t } = useTranslation();

  return (
    <div className={`nc-PayPage `} data-nc-id="PayPage">
      <main className="container mt-11 mb-24 lg:mb-32 ">
        <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold">{t("pay_done_payment_method")}</h3>

            <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
              <div className="flex-1 p-5 flex space-x-4">
                <Grid container>
                  <Grid item md={10} sm={10}>
                    <div className="flex flex-col">
                      <span className="text-sm text-neutral-400">{t("payment_method_fps")}</span>
                      <span className="mt-1.5 text-lg font-semibold">165841446</span>
                      <span className="mt-1.5 text-lg ">Wong K** F***</span>
                    </div>
                  </Grid>
                  <Grid item md={2} sm={2} style={{ flex: 1 }}>
                    <CopyToClipboard
                      onCopy={() => {
                        successAlert(t("copied"));
                      }}
                      text="165841446">
                      <Grid container spacing={0} direction="column" alignItems="flex-end" justifyContent="center" textAlign={"center"} style={{ minHeight: "100%" }}>
                        <Grid item xs={3}>
                          <i className="hover text-neutral-400 text-3xl las la-clipboard"></i>
                        </Grid>
                      </Grid>
                    </CopyToClipboard>
                  </Grid>
                </Grid>
              </div>
              <div className="flex-1 p-5 flex space-x-4">
                <Grid container>
                  <Grid item md={10} sm={10}>
                    <div className="flex flex-col">
                      <span className="text-sm text-neutral-400">{t("payment_method_bank_transfer")}</span>
                      <span className="mt-1.5 text-lg font-semibold">ZA Bank account</span>
                      <span className="mt-1.5 text-lg">8810 0019 5899</span>
                      <span className="mt-1.5 text-lg ">Wong K** F***</span>
                    </div>
                  </Grid>
                  <Grid item md={2} sm={2} style={{ flex: 1 }}>
                    <CopyToClipboard
                      onCopy={() => {
                        successAlert(t("copied"));
                      }}
                      text="881000195899">
                      <Grid container spacing={0} direction="column" alignItems="flex-end" justifyContent="center" textAlign={"center"} style={{ minHeight: "100%" }}>
                        <Grid item xs={3}>
                          <i className="hover text-neutral-400 text-3xl las la-clipboard"></i>
                        </Grid>
                      </Grid>
                    </CopyToClipboard>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
